import { Badge, Group, Paper, Text } from "@mantine/core";
import type { DrgData } from "../../types/encounter-drg";
import { formatCurrency, getTypeBadgeStyle } from "./helpers";
import { CODING_CARD, DRG_INFO_BOX, FONT, TIMELINE_CARD, TW } from "./theme";

const FinalDrgCard = ({ drg }: { drg: DrgData | null }) => {
  return (
    <Paper
      withBorder
      radius="md"
      p="sm"
      style={{
        background: TIMELINE_CARD.coding.bg,
        borderColor: TIMELINE_CARD.coding.border,
      }}
    >
      <Text
        size={`${FONT.xs}px`}
        fw={600}
        c={CODING_CARD.labelColor}
        tt="uppercase"
        style={{ letterSpacing: "0.05em" }}
        mb={4}
      >
        Final DRG
      </Text>
      <Group gap="xs" align="center" wrap="nowrap">
        <Text size={`${FONT.sm}px`} fw={700} c={CODING_CARD.valueColor}>
          {drg?.value || "N/A"}
        </Text>
        <Text size={`${FONT.sm}px`} fw={500} c={TW.gray600} lineClamp={1} style={{ flex: 1 }}>
          {drg?.description || ""}
        </Text>
        {drg?.details?.TYPE && (() => {
          const typeBadge = getTypeBadgeStyle(drg.details.TYPE);
          return (
            <Badge
              size="xs"
              variant="light"
              styles={{
                root: {
                  backgroundColor: typeBadge.bg,
                  color: typeBadge.text,
                  borderColor: typeBadge.border,
                  borderWidth: 1,
                  borderStyle: "solid",
                  height: 16,
                  paddingLeft: 6,
                  paddingRight: 6,
                  fontSize: 10,
                  fontWeight: 500,
                  flexShrink: 0,
                },
              }}
            >
              {drg.details.TYPE}
            </Badge>
          );
        })()}
        {drg?.details?.DOLLARS && (
          <Badge
            size="sm"
            styles={{
              root: {
                backgroundColor: DRG_INFO_BOX.dollarBg,
                color: DRG_INFO_BOX.dollarText,
                borderColor: DRG_INFO_BOX.dollarBorder,
                borderWidth: 1,
                borderStyle: "solid",
                fontSize: FONT.xs,
                flexShrink: 0,
              },
            }}
          >
            {formatCurrency(drg.details.DOLLARS)}
          </Badge>
        )}
      </Group>
    </Paper>
  );
};

export default FinalDrgCard;
